import { getFileName } from "@/utils/files";
import { toDate } from "@/utils/date/to-date";
import { formatDate } from "@/utils/date/format";
import { DictionaryAnswerItem } from "./DictionaryItem";

export function ProfileFieldAnswer(data) {
    if (!data) return null;

    if (typeof data === "string") {
        const number = parseFloat(data);

        return {
            string: data,
            date: data,
            number: Number.isNaN(number) ? null : number,
        };
    }

    const {
        id,
        value_date,
        value_date_period,
        value_item_id,
        value_json,
        value_number,
        value_string,
        values,
        profileValueFiles,
    } = data;

    let dictionaries = [];

    if (values) {
        dictionaries = values.map(DictionaryAnswerItem).filter(Boolean);
    }

    function formatDateValue(date) {
        const d = toDate(date, "server");
        return formatDate(d);
    }

    const files = profileValueFiles || [];
    files.sort((a, b) => a.id - b.id);

    const number = parseFloat(value_number);

    return {
        id,
        string: value_string,
        number: Number.isNaN(number) ? null : number,
        date: formatDateValue(value_date),
        period: formatDateValue(value_date_period),
        itemId: value_item_id,
        json: value_json,
        dictionaries,
        files: files.map((file) => {
            const { id, name } = file;
            const url = `/${name}`;
            const fileName = getFileName(url);
            return {
                id,
                url,
                name: fileName,
            };
        }),
    };
}
